"use client";

import { Link } from "react-router-dom";

export default function HeaderStrip() {
  return (
    <div className="bg-orange text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 h-20 flex items-center justify-between">
        <nav className="flex items-center gap-2 text-sm">
          <Link to="/" className="hover:text-cream transition-colors">
            Home
          </Link>
          <span className="text-white/60">{">"}</span>
          <span className="text-white/90">Services</span>
          <span className="text-white/60">{">"}</span>
          <span className="text-white/90">Emergency Board-Up</span>
        </nav>
        <span className="text-sm font-medium">Same-Day Response</span>
      </div>
    </div>
  );
}